import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const BreakPriceLine = observer(
  ({ tradePlanId, priceToBreak, size, scaleY, portalRef,
     fillPrice, openQuantity, priceMultiplier, realizedPnl, isLong, tickSize, delta }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const paused = tradePlan?.exitTactics['BREAK_PRICE']?.paused ?? null;
    const price = Number(priceToBreak);
    const json = {
      Category: 'Exit Tactic',
      Type: 'Underlying Break Price',
    };
    return (
      <>
        {scaleY ? (
          <>
            {paused ? (
              <line
                strokeDasharray="4"
                stroke={colors.red}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(price)}
                y2={scaleY(price)}
              />
            ) : (
              <line
                stroke={colors.red}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(price)}
                y2={scaleY(price)}
              />
            )}

            <HoverBox
              json={json}
              topBoundary={scaleY(price) - 2}
              bottomBoundary={scaleY(price) + 2}
              leftBoundary={0}
              rightBoundary={size}
              portalRef={portalRef}
              size={size}
              linePrice={price}
              tickSize={tickSize}
              fillPrice={fillPrice}
              openQuantity={openQuantity}
              priceMultiplier={priceMultiplier}
              realizedPnl={realizedPnl}
              isLong={isLong}
              delta={delta}
            />
          </>
        ) : null}
      </>
    );
  }
);

BreakPriceLine.propTypes = {
  priceToBreak: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.number,
  portalRef: PropTypes.object,
  fillPrice: PropTypes.number,
  openQuantity: PropTypes.number,
  priceMultiplier: PropTypes.number,
  realizedPnl: PropTypes.number,
  isLong: PropTypes.bool,
  tickSize: PropTypes.number,
  delta: PropTypes.number,
};
